import { useSite } from "@/context/SiteContext";

export const Marquee = () => {
  const { content } = useSite();
  const words = content.marquee || [];
  if (!words.length) return null;
  const row = [...words, ...words];
  return (
    <div data-testid="herb-marquee" className="marquee overflow-hidden border-y border-forest/10 bg-sand py-6 sm:py-8" aria-label="Key herbs">
      <div className="marquee-track">
        {[0, 1].map((k) => (
          <div key={k} className="flex shrink-0 items-center" aria-hidden={k === 1}>
            {row.map((w, i) => (
              <span key={`${k}-${i}`} className="flex items-center text-3xl font-extrabold tracking-[-0.02em] text-forest sm:text-5xl">
                <span className="px-6 sm:px-10">{w}</span>
                <svg viewBox="0 0 20 20" className="h-5 w-5 text-gold sm:h-7 sm:w-7" fill="currentColor"><path d="M10 0c1 6 4 9 10 10-6 1-9 4-10 10-1-6-4-9-10-10 6-1 9-4 10-10z" /></svg>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
